import { AuthAccountOrganizationJobPositionStatusChoices, Loading, SearchBox } from "@cpj-ai/panel-npm-package";
import { useGetJobPositionsQuery } from "@graphql/generated";
import JobPositionList from "@modules/JobPosition/pages/JobPositionList/components/JobPositionList";
import { IFormData, getInputConfigs } from "@modules/JobPosition/pages/JobPositionList/searchBoxFormConfig";
import { useState } from "react";

type JobPositionSelectionStepProps = {
  setJobPositionId: (jobPositionId: string | null) => void;
  onStepChange: (step: "confirmAssignment" | "jobPositionSelection") => void;
};

const JobPositionSelectionStep: React.FC<JobPositionSelectionStepProps> = ({ setJobPositionId, onStepChange }) => {
  const [page, setPage] = useState(1);
  const pageSize = 5;
  const [currentFilters, setCurrentFilters] = useState<IFormData>({});

  const {
    data: jobPositions,
    loading,
    refetch,
  } = useGetJobPositionsQuery({
    variables: {
      first: pageSize,
      status: AuthAccountOrganizationJobPositionStatusChoices.PUBLISHED,
    },
  });

  const filterData = (formData: IFormData) => {
    setPage(1);
    setCurrentFilters(formData);
    refetch({
      title: formData.title,
      status: AuthAccountOrganizationJobPositionStatusChoices.PUBLISHED,
      startDate: formData.date?.[0],
      endDate: formData.date?.at(-1),
      first: pageSize,
      offset: 0,
    });
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    refetch({
      title: currentFilters.title,
      status: AuthAccountOrganizationJobPositionStatusChoices.PUBLISHED,
      startDate: currentFilters.date?.[0],
      endDate: currentFilters.date?.at(-1),
      first: pageSize,
      offset: (newPage - 1) * pageSize,
    });
  };

  const handleRowClick = (id?: string) => {
    setJobPositionId(id ?? null);
    onStepChange("confirmAssignment");
  };

  return (
    <>
      <div className="sticky top-0 z-10 bg-white flex flex-col pt-4">
        <SearchBox inputConfigs={getInputConfigs(true)} filterItems={filterData} formGridSize={9} />
      </div>
      {loading ? (
        <Loading className="pt-40" />
      ) : (
        <JobPositionList
          jobPositions={jobPositions}
          currentPage={page}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onRowClick={handleRowClick}
          showPageSize={false}
        />
      )}
    </>
  );
};

export default JobPositionSelectionStep;
